const data = {
  id: 1,
  title: 'Listen and rearrange the words to make the correct sentence.',
  subTitle: 'Nghe và sắp xếp lại các từ để tạo thành câu đúng.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/317e4f70-05b2-4f70-bb43-dba27b54983c.mp3',
  imageUrl: '',
  question: "What is your brother's home address?",
  answer: "What is your brother's home address?",
  settings: {
    question: {
      shuffedType: 'word',
      // shuffedType: 'character',
    },
  },
};

export default data;
